const swtkn = require("../../../abi/SWDTKN.json")
const bytecode = swtkn.bytecode
const abi = swtkn.abi

const deploy = async (senderWallet, web3) => {
    let options = {
        data: bytecode,
        arguments: []
    }
    console.log(senderWallet)
    let gas = 8000000
    let maxPriorityFeePerGas = "40000000000"
    let maxFeePerGas = "85000000000"
    const contractToDeploy = await new web3.eth.Contract(abi)
        .deploy(options)
        .send({ from: senderWallet, gas: gas, maxPriorityFeePerGas: maxPriorityFeePerGas, maxFeePerGas: maxFeePerGas, chainId: 137 })
}

export { deploy }
